module.exports = __webpack_public_path__ + "static/img/main.c56db43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhongqiu/main.png
// module id = BMg4
// module chunks = 1